<div class="console-page">

  <div class="console-content">

    <app-page-header

      title="Control del simulador"

      description="Simula respuestas para transacciones Agora pendientes."

    >

      <div actions class="sim-toolbar">

        <app-environment-badge [env]="selectedEnv"></app-environment-badge>

        <div class="console-field sim-toolbar__env">

          <label class="console-field__label">Ambiente</label>

          <select class="console-select" [value]="selectedEnv" (change)="onEnvChange($any($event.target).value)">

            <option value="QA">QA</option>

            <option value="DEV">DEV</option>

          </select>

        </div>

        <button type="button" class="console-btn" (click)="refresh()" [disabled]="loading && filteredProcesses.length === 0">Actualizar</button>

      </div>

    </app-page-header>



    <div class="console-field sim-search">

      <label class="console-field__label">Buscar procesos</label>

      <input
        class="console-input"
        [(ngModel)]="filterText"
        (ngModelChange)="onFilterChange()"
        placeholder="ID, teléfono o documento"
      />

    </div>



    <div class="sim-meta" *ngIf="filteredProcesses.length > 0 || !loading">

      <h2 class="console-section__title">Procesos pendientes</h2>

      <span class="sim-meta__count tabular">{{ filteredProcesses.length }}</span>

    </div>



    <p class="console-field__hint" *ngIf="filteredProcesses.length > 0 || !loading">La cola se actualiza automáticamente cada 30 segundos. Usá Actualizar para refrescar al instante.</p>



    <div class="alert-banner alert-banner--error" *ngIf="loadError">{{ loadError }}</div>



    <div *ngIf="loading && filteredProcesses.length === 0" class="sim-loading">Cargando…</div>



    <app-empty-state

      *ngIf="!loading && !loadError && filteredProcesses.length === 0"

      title="No hay procesos pendientes"

      detail="Iniciá un pago Agora en Checkout y volvé acá. La cola se refresca cada 30 segundos o con el botón Actualizar."

    ></app-empty-state>



    <div class="sim-table-wrap console-data-table" *ngIf="filteredProcesses.length > 0">

      <table mat-table [dataSource]="queueDataSource" class="console-table">

        <ng-container matColumnDef="id">

          <th mat-header-cell *matHeaderCellDef class="sim-col-id">ID</th>

          <td mat-cell *matCellDef="let row" class="sim-col-id">

            <div class="mono">

              <span [title]="row.identiifier">{{ truncateId(row.identiifier) }}</span>

              <app-copy-button [value]="row.identiifier" ariaLabel="Copiar ID"></app-copy-button>

            </div>

          </td>

        </ng-container>

        <ng-container matColumnDef="phone">

          <th mat-header-cell *matHeaderCellDef>Teléfono</th>

          <td mat-cell *matCellDef="let row">{{ row.requestData?.phone }}</td>

        </ng-container>

        <ng-container matColumnDef="document">

          <th mat-header-cell *matHeaderCellDef>Documento</th>

          <td mat-cell *matCellDef="let row">{{ row.requestData?.documentNumber }}</td>

        </ng-container>

        <ng-container matColumnDef="amount">

          <th mat-header-cell *matHeaderCellDef>Monto</th>

          <td mat-cell *matCellDef="let row" class="tabular">S/ {{ row.requestData?.amount }}</td>

        </ng-container>

        <ng-container matColumnDef="status">

          <th mat-header-cell *matHeaderCellDef>Estado</th>

          <td mat-cell *matCellDef="let row">

            <app-status-badge tone="pending" label="Pendiente"></app-status-badge>

          </td>

        </ng-container>

        <ng-container matColumnDef="actions">

          <th mat-header-cell *matHeaderCellDef>Acciones</th>

          <td mat-cell *matCellDef="let row" class="sim-actions-cell">
            <button
              type="button"
              class="console-btn"
              (click)="toggleActionMenu(row.identiifier, $event)"
              [attr.aria-expanded]="openActionMenuId === row.identiifier"
              aria-haspopup="menu"
              aria-label="Acciones del proceso"
            >
              Acciones
            </button>
          </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>

      <mat-paginator
        class="console-paginator"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="defaultPageSize"
        showFirstLastButtons
        aria-label="Seleccionar página"
      ></mat-paginator>

    </div>



    <div
      *ngIf="openActionMenuId as actionId"
      class="sim-actions-popover"
      role="menu"
      [style.top.px]="actionMenuPos.top"
      [style.left.px]="actionMenuPos.left"
      (click)="$event.stopPropagation()"
    >
      <button type="button" role="menuitem" class="sim-actions-popover__item" (click)="ejecutarAutorizar(actionId)">
        Autorizar
      </button>
      <button type="button" role="menuitem" class="sim-actions-popover__item" (click)="ejecutarError98(actionId)">
        Simular error 98
      </button>
    </div>

  </div>

</div>

